import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "../../css/herosection.css"; 
import { FaSearch } from "react-icons/fa";
import b11 from '../../images/view-city-square.jpg'
import localityData from '../../assets/Locality.json'

export const Herosection = () => {
  const [filters, setFilters] = useState({}); 
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("New Project");
  const [propertyCategory, setPropertyCategory] = useState("Residential"); 
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [showPropertyOptions, setShowPropertyOptions] = useState(false);
  const buttonRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [showSearchBox, setShowSearchBox] = useState(true);
  const [filteredLocalities, setFilteredLocalities] = useState([]);
const [showDropdown, setShowDropdown] = useState(false);

  const residentialOptions = ["Apartment", "Villa", "Plot", "Independent Floor"];
  const commercialOptions = [
    "Office Space",
    "Shop/Showroom",
    "Commercial Land",
    "Coworking Space",
    "Warehouse/Godown",
    "Industrial Building",
    "Industrial Shed",
  ];

  const togglePropertyType = (property) => {
    setSelectedPropertyTypes((prev) =>
      prev.includes(property) ? prev.filter((item) => item !== property) : [...prev, property]
    );
  };

  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedPropertyTypes([]);
    setShowPropertyOptions(false); // Close the property type dropdown when changing tabs

    setPropertyCategory(tab === "Commercial" ? "Commercial" : "Residential");
    
    let listingType = "";
    let propertyType = "";

    if (tab === "New Project") {
      listingType = "Resale";
    } else if (tab === "Rent") {
      listingType = "Rent";
    } else if (tab === "Commercial") {
      propertyType = "Commercial";
    } else if (tab === "PG/Coliving") {
      listingType = "PG-Co Living";
      propertyType = "Residential";
    }

    setFilters((prevFilters) => ({
      ...prevFilters,
      listingType,
      propertyType,
    }));
     };

  const closeTypeOptions = () => {
    setShowPropertyOptions(false);
  };

  const handleSearch = () => {
    const queryParams = new URLSearchParams();

    if (searchQuery.trim()) queryParams.set("locality", searchQuery);
    queryParams.set("propertyType", propertyCategory);
    
    if (activeTab === "New Project") {
      queryParams.set("listingType", "Resale");
    } else if (activeTab === "Rent") {
      queryParams.set("listingType", "Rent");
    } else if (activeTab === "Commercial") {
      queryParams.set("propertyType", "Commercial");
      queryParams.set("listingType", "Resale");
    } else if (activeTab === "PG Coliving") {
      queryParams.set("listingType", "PG/Co-living");
      queryParams.set("propertyType", "Residential");
    }

    if (selectedPropertyTypes.length > 0) {
      queryParams.set("proptypename", selectedPropertyTypes.join(","));
    } else {
      queryParams.delete("proptypename");
    }

    if (activeTab === "New Project") {
      navigate(`/new-projects-search?type=${propertyCategory}&propertytype=${selectedPropertyTypes.join(",")}&locality=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      navigate(`/search?${queryParams.toString()}`);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows:false,
  };

  useEffect(() => {
    const index = ["New Project", "Commercial",  "Rent", "PG Coliving"].indexOf(activeTab);
    const currentBtn = buttonRefs.current[index];
    if (currentBtn) {
      setIndicatorStyle({
        width: `${currentBtn.offsetWidth}px`,
        transform: `translateX(${currentBtn.offsetLeft}px)`,
      });
    }
  }, [activeTab]);

  return (
    <div className="new-hero">
      <div className="new-hero-banner">
        <Slider {...settings}>
          <div><img src={b11} alt="Real Estate" /></div>
          <div><img src={b11} alt="Real Estate" /></div>
          <div><img src={b11} alt="Real Estate" /></div>
        </Slider>
        <div className="overlay"></div>
      </div>
      <div className="new-search-section">
      <div className="new-hero-overlay">
        {/* <h3 className="cursor typewriter-animation">Find Your Dream Home with 0% Brokerage 
      </h3> */}
      <h1>Find Your Dream Home with 0% Brokerage </h1>
       <span> Chennai’s Most Trusted Property Partner</span>
      </div>
        <div className="new-search-tabs">
          <div className="tab-buttons-wrapper">
            {["New Project",  "Commercial", "Rent", "PG Coliving"].map((tab, index) => (
              <button
                key={tab}
                ref={(el) => (buttonRefs.current[index] = el)}
                className={`tab-btn ${activeTab === tab ? "new-active-tab" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
            <div className="tab-indicator" style={indicatorStyle}></div>
          </div>
        </div>

        {activeTab !== "PG Coliving" && showSearchBox && (
        <div className="new-search-filters">
          <div className="btn-type">
            {activeTab !== "Commercial" && (
              <select
                value={propertyCategory}
                onChange={(e) => {
                  setPropertyCategory(e.target.value);
                  setSelectedPropertyTypes([]);
                  closeTypeOptions(); // Close dropdown when selecting property type
                }}
                className="property-dropdown"
              >
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
              </select>
            )}

            <button className="toggle-options-btn" onClick={() => setShowPropertyOptions(!showPropertyOptions)}>
              {showPropertyOptions ? "Hide Types" : "+ Select Type"}
            </button>
          </div>

          {showPropertyOptions && (
            <div className="property-options">
              {(propertyCategory === "Residential" ? residentialOptions : commercialOptions).map((type) => (
                <label key={type} className="property-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedPropertyTypes.includes(type)}
                    onChange={() => togglePropertyType(type)}
                  />
                  {type}
                </label>
              ))}
            </div>
          )}

          <input
            type="text"
            placeholder="Enter Locality, Landmark, or Project..."
            value={searchQuery}
            onChange={(e) => {
              const value = e.target.value;
              setSearchQuery(value);
          
              if (value.trim().length > 0) {
                const results = localityData.cma_localities.filter((item) =>
                  item.locality.toLowerCase().includes(value.toLowerCase())
                );
                setFilteredLocalities(results);
                setShowDropdown(true);
              } else {
                setFilteredLocalities([]);
                setShowDropdown(false);
              }
            }}
            onFocus={closeTypeOptions} // Close the dropdown when focusing on the input
          />

{showDropdown && filteredLocalities.length > 0 && (
  <ul className="dropdown-locality-list">
    {filteredLocalities.map((item, index) => (
      <li
        key={index}
        className="dropdown-locality-item"
        onClick={() => {
          setSearchQuery(item.locality);
          setShowDropdown(false);
        }}
      >
        {item.locality} ({item.district})
      </li>
    ))}
  </ul>
)}

          <button onClick={handleSearch}>Search</button>
        </div>
)}
        {activeTab === "PG Coliving" && (
          <div className="pg">
            <div className="new-search-filters">
              <input
                type="text"
                placeholder="Enter Locality..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={closeTypeOptions}
              />
              <button onClick={handleSearch}>Search</button>
            </div>
          </div>
        )}
      </div>
      </div>
    
  );
};
